import { NavigateFunction } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';
import { generateInitialsAvatar } from '../utils/avatarUtils';

export const navigateToPublicProfile = async (
  userId: string,
  navigate: NavigateFunction
) => {
  try {
    const [userDoc, profileSettingsDoc] = await Promise.all([
      getDoc(doc(db, 'users', userId)),
      getDoc(doc(db, 'profileSettings', userId))
    ]);

    if (userDoc.exists()) {
      const userData = userDoc.data();
      const settingsData = profileSettingsDoc.exists() ? profileSettingsDoc.data() : {};
      
      // Récupérer la photo de profil depuis localStorage
      const savedProfilePicture = localStorage.getItem(`user_${userId}_profilePicture`);
      
      // Générer l'avatar par défaut si nécessaire
      const defaultAvatar = generateInitialsAvatar(userData.username || 'Anonyme');
      
      // Utiliser la photo dans cet ordre de priorité:
      // 1. Photo sauvegardée dans localStorage
      // 2. Photo du profil utilisateur
      // 3. Photo des paramètres du profil
      // 4. Avatar par défaut
      const profilePicture = savedProfilePicture || 
                           userData.profilePicture || 
                           settingsData.profilePicture || 
                           defaultAvatar;

      navigate(`/profil/${userId}`, {
        state: {
          userId: userId,
          username: userData.username || 'Anonyme',
          description: userData.description || '',
          amountGiven: userData.amountGiven || 0,
          likes: userData.likes || 0,
          socialLinks: userData.socialLinks || [],
          photos: userData.photos || [],
          profilePicture: profilePicture
        }
      });
    }
  } catch (error) {
    console.error('Erreur lors de la navigation vers le profil:', error);
  }
}; 